<template>
  <div>
    <PageMain ref="main" @change="(e) => $emit('change', e)">
      <template #header>
        <div class="d-flex align-items-center">
          <h6 class="m-0" style="color:#101010">
            {{ $l('form_header_mixed') || '单箱混装方案' }}
          </h6>
          <el-divider direction="vertical"></el-divider>
          <el-button
            size="mini"
            type="success"
            plain
            @click="chooseSkuVisible = true"
          >
            {{ $l('btn_mixed_chooseSku') || '选择产品' }}
          </el-button>
        </div>
      </template>
    </PageMain>

    <ChooseSku
      :title="$l('dialog_title_addMixedSku') || '添加混装产品'"
      :visible.sync="chooseSkuVisible"
      :platformCode="platformCode"
      @confirm="chooseSkuConfirm"
    />
  </div>
</template>
<script>
import PageMain from './main.vue'
import ChooseSku from '../../choose-sku'
export default {
  components: { PageMain, ChooseSku },
  props: { platformCode: { type: String, default: '' } },
  data() {
    return { chooseSkuVisible: false }
  },
  methods: {
    async validate() {
      const tableData = this.getTableData()

      if (!tableData?.length) {
        this.$message({
          message:
            this.$l('tips_warning_mixedSku_empty') ||
            '请选择单箱混装方案产品！',
          type: 'warning',
          showClose: true,
        })
      }

      if (tableData.length && tableData.length < 2) {
        this.$message({
          message:
            this.$l('tips_warning_mixedSku_error') ||
            '单箱混装方案至少需要两个产品！',
          type: 'warning',
          showClose: true,
        })
      }

      const result = await this.$refs.main.validate()
      return result && tableData?.length && tableData.length >= 2
    },
    getTableData() {
      return this.$refs.main.getTableData()
    },
    chooseSkuConfirm(data) {
      if (!data?.length) return

      const $main = this.$refs.main

      const tableData = $main.getTableData()

      const rows = data
        .filter((item) => {
          const result = tableData.find(
            (row) => row.evgSkuPlatformCode === item.evgSkuPlatformCode
          )
          return !result
        })
        .map((row) => ({ ...row, unitInCtnQty: 0, specInCtnQty: 0 }))

      if (!rows?.length) return
      $main.insertAt(rows)
    },
  },
}
</script>
